import * as React from 'react';

import { PaperProps } from '@mui/material/Paper';
import Popover from '@mui/material/Popover';
import { Box, SxProps, Theme } from '@mui/system';

type Props = {
  handleClose: () => void;
  anchorEl: HTMLElement | HTMLButtonElement | null;
  open: boolean;
  id?: string;
  sx?: SxProps<Theme>;
  // eslint-disable-next-line @typescript-eslint/ban-types
  PaperProps?: Partial<PaperProps<'div', {}>>;
};

const StyledPopover: React.FC<Props> = ({
  handleClose,
  anchorEl,
  open,
  id,
  children,
  sx,
  PaperProps,
}) => {
  const containerRef = React.useRef();

  return (
    <Box ref={containerRef}>
      <Popover
        container={containerRef.current}
        sx={{
          '.MuiPopover-paper': {
            borderRadius: '13px',
            boxShadow: '0px 2.5px 10px 0px rgba(206, 210, 217, 0.8)',
          },
          ...sx,
        }}
        PaperProps={PaperProps}
        elevation={0}
        open={open}
        id={id}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        {children}
      </Popover>
    </Box>
  );
};

export default StyledPopover;
